const PreviewTitleIcon = () => (
  <svg fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.333 25H17.666V21.667H12.333V25ZM3 5V8.333H27V5H3ZM7 16.667H23V13.333H7V16.667Z" fill="#00BD00" />
  </svg>
);

export default PreviewTitleIcon;
